import LicenseArea from "../prototype/ui/LicenseArea.js";

import StatusArea from "./ui/StatusArea.js";
import global from "../prototype/global.js";
const log = global.log.getLogger("f_mtac.configuration");
log.setLevel(log.levels.WARN);

const Commissioning = function () {
    var organization = null;
    this.uri = {};
    Object.defineProperty(this.uri, "config", {
        set: () => {},
        get: () => `/mtac/static/commissioning/${organization}/config.json`
    });
    Object.defineProperty(this.uri, "logo", {
        set: () => {},
        get: () => `/mtac/static/commissioning/${organization}/logo.svg`
    });
    Object.defineProperty(this.uri, "resources", {
        set: () => {},
        get: () => `/mtac/static/commissioning/${organization}/resources.svg`
    });
    Object.defineProperty(this.uri, "license", {
        set: () => {},
        get: () => `/mtac/static/commissioning/${organization}/license.html`
    });
    Object.defineProperty(this, "organization", {
        set: (org) => {
            // setter used for admin page
            organization = org;
        },
        get: () => organization
    });

    const update_cache = async () => {
        const commissioning_cache = await window.caches.open("commissioning");
        // configuration file not added to cache in order to reload file
        // needed to avoid manually cahce deletion when changes not taken into account after reinstalling app
        await commissioning_cache.addAll([/*this.uri.config, */ this.uri.logo, this.uri.resources]);
    };

    const check_license = async () => {
        if (global.configuration.commissioning.license_accepted) {
            return;
        }
        await LicenseArea.interact();
        global.configuration.commissioning.license_accepted = true;
        global.configuration.commit_store("commissioning");
    };

    this.init = async () => {
        await global.configuration.add_store("commissioning", {organization: null, license_accepted: false});
        organization = global.configuration.commissioning.organization;
        if (organization === null) {
            organization = global.configuration.user.org_id;
            global.configuration.commissioning.organization = organization;
            global.configuration.commit_store("commissioning");
        }
        await update_cache();
        check_license();
    };
};

global.app.bootstrap.register_module({
    name: "commissioning",
    deps: ["app", "server", "registrar"],
    init: async () => {
        global.commissioning = new Commissioning();
        await global.commissioning.init();
        await StatusArea.refresh_logo();
    }
});

export default Commissioning;
